var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExcel = function SvgExcel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 140,
    viewBox: "0 0 296 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7277_9261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    fill: "#F5F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.551 53.9996C119.551 47.1242 125.124 41.5507 132 41.5507H164C170.875 41.5507 176.448 47.1242 176.448 53.9996V85.9996C176.448 92.8749 170.875 98.4485 164 98.4485H132C125.124 98.4485 119.551 92.8749 119.551 85.9996V53.9996Z",
    stroke: "#8D83FB",
    strokeWidth: 3.54667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.032 75.3247H145.703V64.667",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 64.667L139.613 75.3247",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.613 64.667L132 75.3247",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.671 64.972C161.671 64.972 156.07 63.4913 155.619 67.0654C155.167 70.6396 162.932 68.9914 162.428 72.9119C161.958 76.5584 156.38 75.0054 156.38 75.0054",
    stroke: "#8D83FB",
    strokeWidth: 2.93333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    stroke: "#8D83FB",
    strokeDasharray: "4.5 4.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7277_9261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 140,
    rx: 3,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExcel);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk2IiBoZWlnaHQ9IjE0MCIgdmlld0JveD0iMCAwIDI5NiAxNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF83Mjc3XzkyNjEpIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyOTUiIGhlaWdodD0iMTM5IiByeD0iMi41IiBmaWxsPSIjRjVGNUZGIi8+CjxwYXRoIGQ9Ik0xMTkuNTUxIDUzLjk5OTZDMTE5LjU1MSA0Ny4xMjQyIDEyNS4xMjQgNDEuNTUwNyAxMzIgNDEuNTUwN0gxNjRDMTcwLjg3NSA0MS41NTA3IDE3Ni40NDggNDcuMTI0MiAxNzYuNDQ4IDUzLjk5OTZWODUuOTk5NkMxNzYuNDQ4IDkyLjg3NDkgMTcwLjg3NSA5OC40NDg1IDE2NCA5OC40NDg1SDEzMkMxMjUuMTI0IDk4LjQ0ODUgMTE5LjU1MSA5Mi44NzQ5IDExOS41NTEgODUuOTk5NlY1My45OTk2WiIgc3Ryb2tlPSIjOEQ4M0ZCIiBzdHJva2Utd2lkdGg9IjMuNTQ2NjciLz4KPHBhdGggZD0iTTE1MS4wMzIgNzUuMzI0N0gxNDUuNzAzVjY0LjY2NyIgc3Ryb2tlPSIjOEQ4M0ZCIiBzdHJva2Utd2lkdGg9IjIuOTMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMyIDY0LjY2N0wxMzkuNjEzIDc1LjMyNDciIHN0cm9rZT0iIzhEODNGQiIgc3Ryb2tlLXdpZHRoPSIyLjkzMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzOS42MTMgNjQuNjY3TDEzMiA3NS4zMjQ3IiBzdHJva2U9IiM4RDgzRkIiIHN0cm9rZS13aWR0aD0iMi45MzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNjEuNjcxIDY0Ljk3MkMxNjEuNjcxIDY0Ljk3MiAxNTYuMDcgNjMuNDkxMyAxNTUuNjE5IDY3LjA2NTRDMTU1LjE2NyA3MC42Mzk2IDE2Mi45MzIgNjguOTkxNCAxNjIuNDI4IDcyLjkxMTlDMTYxLjk1OCA3Ni41NTg0IDE1Ni4zOCA3NS4wMDU0IDE1Ni4zOCA3NS4wMDU0IiBzdHJva2U9IiM4RDgzRkIiIHN0cm9rZS13aWR0aD0iMi45MzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjk1IiBoZWlnaHQ9IjEzOSIgcng9IjIuNSIgc3Ryb2tlPSIjOEQ4M0ZCIiBzdHJva2UtZGFzaGFycmF5PSI0LjUgNC41Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzI3N185MjYxIj4KPHJlY3Qgd2lkdGg9IjI5NiIgaGVpZ2h0PSIxNDAiIHJ4PSIzIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";